import { Outlet } from 'react-router-dom';
import { AdminNavbar, AdminSidebar } from '../../components/NavBar';
import styled from 'styled-components';

const AdminHome = () => {
  return (
    <AdminHomeContainer>
      <main className='dashboard'>
        <div>
          <AdminNavbar />
          <div>
            <AdminSidebar />
            <div className='dashboard-page'>
              <h1>AdminHome</h1>
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </AdminHomeContainer>
  );
};

const AdminHomeContainer = styled.section`
  .dashboard {
    display: grid;
    grid-template-columns: 1fr;
  }
  .dashboard-page {
    width: 90vw;
    margin: 0 auto;
    padding: 2rem 0;
  }
  @media (min-width: 992px) {
    .dashboard {
      grid-template-columns: auto 1fr;
    }
    .dashboard-page {
      width: 90%;
    }
  }
`;

export default AdminHome;
